export const introduction = {
  title: `Camp Knut`,
  whatIs: `Camp Knut is a 30-day long training camp, where a group of streamers tries to follow Knut's workout routine and diet.`,
  goal: `Improve fitness, look and health as much as possible in 30 days. The final show will be a fitness/bodybuilding competition.`,
  whoIsKnut: `Knut is a streamer from Norway. He is a professional bodybuilder and a fitness enthusiast.`,
};

export const tips = {
  knowYourLimits: `Remember to take care of your health, you know your own limits
  better than anyone else. If you end up injuring yourself, it
  will only set you further back.`,
  supplements: `Supplements aren't needed, but if you have the money and want to
  maximize your workouts - Go for it!`,
};

export const errors = {
  missingPage: `We couldn't find that page`,
  serverError: "Server error, that's awkward. That wasn't supposed to happen",
};
export const seo = {
  description: `Camp Knut is a 30-day long training camp where Knut will take Mizkif, Nmplol, EsfandTV, Cyr, Lacari, Tectone and Erobb221 through a full bodybuilding experience. By the end of the
  training camp, they will go on a bodybuilding show. They will also be judged by their performance by Knut, WakeWilder, Malena and Asmongold.`,
  title: introduction.title,
};
